import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { getLeadByID, setNewDataLead } from '../../redux/reduxActions/leadActions';


const OpenLead = (props) => {
  const [message, setMessage] = useState('');
  const [funnelStatus, setFunnelStatus] = useState('');
  const { selectedLead, funnelStatuses } = props;
  useEffect(() => {
    props.getLeadByID(props.match.params.id);
  }, []);
  useEffect(() => {
    setFunnelStatus(funnelStatuses
      .find((item) => item.name === 'LeadFirstMessage'));
    setMessage(selectedLead.firstMessage || '');
  }, [props]);

  function setFirstMessage() {
    props.setNewDataLead(selectedLead.id, { status: 1, event_comment: message }, props.history.push, false);
  }

  return (
    <div>
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
							Open Lead
            </h3>
            <Button
              onClick={() => { setFirstMessage(); }}
              variant="primary"
              className="main-button-filled"
            >
							Save
            </Button>
          </div>
          <TextareaAutosize
            onChange={({ target: { value } }) => { setMessage(value); }}
            className="lead_input__first-message"
            rows={3}
            placeholder="..."
          />
        </div>
      </div>
    </div>
  );
};
export default connect((store) => ({
  selectedLead: store.leadReducer.selectedLead,
  funnelStatuses: store.leadReducer.funnelStatuses,
}), { getLeadByID, setNewDataLead })(OpenLead);
